<!-- Header -->
<header class="flex lg:hidden items-center fixed z-10 top-0 start-0 end-0 shrink-0 bg-muted h-(--header-height)" id="header">
    <!-- Container -->
    <div class="kt-container-fluid flex items-center justify-between flex-wrap gap-3">
        <a href="#">
            <img class="dark:hidden min-h-[30px]" src="assets/media/app/mini-logo-gray.svg"/>
            <img class="hidden dark:block min-h-[30px]" src="assets/media/app/mini-logo-gray-dark.svg"/>
        </a>
        <button class="kt-btn kt-btn-icon kt-btn-ghost -me-2" data-kt-drawer-toggle="#sidebar">
            <i class="ki-filled ki-menu">
            </i>
        </button>
    </div>
    <!-- End of Container -->
</header>
<!-- End of Header -->